import LeadDetailsContainer from "./LeadDetailsContainer";

export default LeadDetailsContainer;
